import CMExamConfig from "../../../course_managment/classes/CMExamConfig";


export default class CandidatesQuickReserve extends CMExamConfig{
  constructor(item = {}) {
    super(item)
    this.city = item.city
  }
}